import React, { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "fr";
    return window.localStorage.getItem("ekip-lang") || "fr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("ekip-lang", lang);
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === "fr" ? "en" : "fr")), []);

  const t = useMemo(() => translations[lang] || translations.fr, [lang]);

  const value = useMemo(() => ({ lang, setLang, toggle, t }), [lang, toggle, t]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
